import { Component, OnInit ,Input ,EventEmitter ,Output} from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';

@Component({
  selector: 'app-table-postmaster-count',
  templateUrl: './table-postmaster-count.component.html',
  styleUrls: ['./table-postmaster-count.component.scss']
})
export class TablePostmasterCountComponent implements ViewCell,OnInit {

  @Input() value : string|number;
  @Input() rowData : string|number;

  @Output() onCountClick: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit() {
        console.log("",this.rowData);
        console.log("------------>",this.value);
  }
  onClick(){
        this.onCountClick.emit(this.rowData);
        return false;
  }

}